import waffleClient from '@/api/waffle.js'

// The request in progress, so callers waiting on it share one.
let inFlight = null

// initial state
const state = {
  features: [],
  loaded: false
}

// getters
const getters = {
  features (state) {
    return state.features
  },

  isFeatureEnabled: (state) => (featureName) => {
    return state.features.includes(featureName)
  }
}

// actions
const actions = {
  fetch: (context) => {
    inFlight = waffleClient.waffleStatus()
      .then((response) => {
        const data = response.data
        // The API returns nested switches, flags and samples which may be active or inactive.
        // We want a list of features that are active and we don't care if they are
        // switches, flags or samples so we will flatten them into a single array.
        const features = []
        Object.entries(data.flags).forEach(([key, value]) => {
          if (value.is_active) {
            features.push(key)
          }
        })
        Object.entries(data.switches).forEach(([key, value]) => {
          if (value.is_active) {
            features.push(key)
          }
        })
        Object.entries(data.samples).forEach(([key, value]) => {
          if (value.is_active) {
            features.push(key)
          }
        })
        context.commit(SET_FEATURES, features)
        context.commit(SET_LOADED)
        return features
      })
      .finally(() => {
        inFlight = null
      })
    return inFlight
  },

  // Resolves once features have loaded at least once, for decisions that
  // can't wait for a refresh but mustn't be made before the first load.
  ensureLoaded: (context) => {
    if (context.state.loaded) {
      return Promise.resolve(context.state.features)
    }
    return inFlight || context.dispatch('fetch')
  },

  clear: (context) => {
    context.commit(SET_FEATURES, [])
  }
}

// mutations
const SET_FEATURES = 'SET_FEATURES'
const SET_LOADED = 'SET_LOADED'

const mutations = {
  [SET_FEATURES]: (state, features) => {
    state.features = features
  },

  [SET_LOADED]: (state) => {
    state.loaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
